import { render, staticRenderFns } from "./FlightInformations.vue?vue&type=template&id=cb871f4c&scoped=true"
import script from "./FlightInformations.vue?vue&type=script&lang=js"
export * from "./FlightInformations.vue?vue&type=script&lang=js"
import style0 from "./FlightInformations.vue?vue&type=style&index=0&id=cb871f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb871f4c",
  null
  
)

export default component.exports